export default __webpack_public_path__ + "images/75876a23879aee7012406aa679f3944a-BSHSync.svg";